import React  from "react";
import { useParams } from 'react-router-dom';
import JobRoleForm from "./components/JobRoleForm";
import Card from "components/card";

const EditJobRole = () => {

	const { roleId } = useParams();

	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<JobRoleForm recordId={roleId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditJobRole;